export enum SELECT_TIME_SLOTS_STATES {
  INITIAL = 'INITIAL',
  SLOTS_FETCHING = 'SLOTS_FETCHING',
  GET_ERROR = 'ERROR',
  GET_SUCCESS = 'GET_SUCCESS',
  DAY_SELECTED = 'DAY_SELECTED',
  HOUR_SELECTED = 'HOUR_SELECTED',
}
